/** Modules accessibles par l'utilisateur (menu et garde de route), résolus côté backend depuis ses rôles attribués. */
export function canAccessModule(user: { modules: string[] } | undefined | null, moduleKey: string): boolean {
  if (!user) return false
  // Regroupement d'écrans de reporting finance côté UI, sans permission backend dédiée.
  if (moduleKey === 'caisse') return user.modules.includes('finance')
  return user.modules.includes(moduleKey)
}
